export const formatCurrency = (value: number): string => {
  const abs = Math.abs(value);
  const formatted = new Intl.NumberFormat(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(abs);
  return `${value < 0 ? '-' : ''}$${formatted}`;
};
